const CUSTOM_HTTP_HEADERS = {
  shouldSaveSession: "BEN-Should-Save-Session",
  shouldNotRedirect: "BEN-Should-Not-Redirect",
};

export {
  CUSTOM_HTTP_HEADERS,
};
